
function SingleJewel(){

    this.build();

}

SingleJewel.prototype.build = function(){

    let that = this;

    let images = $('.single-jewel-slider img');
    let imageLoadedCpt = 0;
    images.each(function (index, elem) {
        let self = $(elem);
        self.on('load', function(){
            imageLoadedCpt++;
            if( imageLoadedCpt === images.length - 1 || images.length === 1 ){
                that.initSlider();
            }
        }).attr("src", self.attr('src'));
    });

};

SingleJewel.prototype.initSlider = function(){

    let that = this;

    let slider = $('.single-jewel-slider').slick({
        arrows: false,
        infinite: false,
        speed: 800,

        vertical: true,
        verticalSwiping: true,

        responsive: [
            {
                breakpoint : 768,
                settings : {

                    vertical: false,
                    verticalSwiping: false

                }
            }
        ]

    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        that.slideChange(nextSlide);
    }).addClass('slick-ready');

    $('.single-jewel-slider-dots').on('click', function(){
        slider.slick('slickGoTo', $(this).index());
    });

};

SingleJewel.prototype.slideChange = function( index ){
    $('.single-jewel-slider-dots').removeClass('single-jewel-slider-dots--current');
    $('.single-jewel-slider-dots:eq(' + index + ')').addClass('single-jewel-slider-dots--current');
};
